import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ProductDetails from "@/views/ProductDetails.vue";
import BasketSummary from "@/views/BasketSummary.vue";
import VerifyPayment from "@/components/VerifyPayment.vue";
import Imprint from "@/views/Imprint.vue";
import Privacy from "@/views/Privacy.vue";
import ImageDownloadView from "@/views/ImageDownloadView.vue";
import TOS from "@/views/TOS.vue";
import NewsletterUnsubscribe from "@/views/NewsletterUnsubscribe.vue";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/product/:id',
            name: 'product',
            component: ProductDetails
        },
        {
            path: '/basket',
            name: 'basket',
            component: BasketSummary
        },
        {
            path: '/verifyPayment/:token',
            props: true,
            name: 'verifyPayment',
            component: VerifyPayment
        },
        {
            path: '/download/:code',
            name: 'download',
            component: ImageDownloadView
        },
        {
            path: '/newsletter/unsubscribe/:token',
            name: 'newsletterUnsubscribe',
            component: NewsletterUnsubscribe
        },
        {
            path: '/imprint',
            name: 'imprint',
            component: Imprint
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy
        },
        {
            path: '/tos',
            name: 'tos',
            component: TOS
        }
    ]
});

// Redirect if path begins with a hash (ignore hashes later in path)
router.beforeEach((to, from, next) => {
    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0, 2) === '/#') {
        const path = to.fullPath.substr(2);
        next(path);
        return;
    }
    next();
});

export default router;